// YERİ: src/app/domains/site/sections/faq.section.ts
// SSS — native <details> accordion (JS gerektirmez, erişilebilir).

import { inject, Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface Faq { q: string; a: string; }

@Component({
  selector: 'sec-faq',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="faq" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-3xl px-6 lg:px-8">
        <div class="text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
        </div>
        <div class="mt-12 space-y-3">
          @for (f of items(); track f.q) {
            <details class="group rounded-xl border border-neutral-200 bg-white p-5 dark:border-neutral-800 dark:bg-neutral-950">
              <summary class="flex cursor-pointer list-none items-center justify-between gap-4 font-medium text-neutral-900 dark:text-white">
                {{ f.q }}
                <m-icon name="chevron-down" size="sm" class="shrink-0 text-neutral-400 transition group-open:rotate-180" />
              </summary>
              <p class="mt-3 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ f.a }}</p>
            </details>
          }
        </div>
      </div>
    </section>
  `,
})
export class FaqSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', this.text.t('sd.sss')));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.sikcaSorulanSorular')));
  protected items = computed<Faq[]>(() => cfg<Faq[]>(this.config(), 'items', [
    { q: this.text.t('fb.ilkGorusmeUcretliMi'), a: this.text.t('fb.ilkDegerlendirmeGorusmemizUcretsizdir') },
    { q: this.text.t('fb.davalarNeKadarSurer'), a: this.text.t('fb.sureDavaTuruneVe') },
    { q: this.text.t('fb.vekaletUcretiNasilBelirlenir'), a: this.text.t('fb.ucretDavaTuruVe') },
    { q: this.text.t('fb.bilgilerimGizliKalirMi'), a: this.text.t('fb.avukatMuvekkilGizliligiEsastir') },
  ]));
}
